/**
 * Debounce sem `useEffect` (`07-spec-front.md` critério F7): usado no início
 * de um `queryFn`. O React Query cancela a query anterior quando a `queryKey`
 * muda antes dela resolver — então só a última chamada, depois de `ms` sem
 * uma nova, chega a bater na API.
 */
export function sleepUnlessAborted(ms: number, signal?: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
      return;
    }
    const timer = setTimeout(resolve, ms);
    signal?.addEventListener(
      'abort',
      () => {
        clearTimeout(timer);
        reject(signal.reason);
      },
      { once: true },
    );
  });
}
